<script lang="ts">
  import Question1 from "./Question1.svelte"
  import Question2 from "./Question2.svelte"
  import Question3 from "./Question3.svelte"
  import Question4 from "./Question4.svelte"
  import Question5 from "./Question5.svelte"
  import Question6 from "./Question6.svelte"
  import Question7 from "./Question7.svelte"
  import Question8 from "./Question8.svelte"
  import Question9 from "./Question9.svelte"
  import Question10 from "./Question10.svelte"
  import Question11 from "./Question11.svelte"
  import Question12 from "./Question12.svelte"
  import Question13 from "./Question13.svelte"
  import Question14 from "./Question14.svelte"
  import Question15 from "./Question15.svelte"

  let props = $props()
  let { question, answer } = props
</script>

{#if question == 1}
  <Question1 {answer} />
{:else if question == 2}
  <Question2 {answer} />
{:else if question == 3}
  <Question3 {answer} />
{:else if question == 4}
  <Question4 {answer} />
{:else if question == 5}
  <Question5 {answer} />
{:else if question == 6}
  <Question6 {answer} />
{:else if question == 7}
  <Question7 {answer} />
{:else if question == 8}
  <Question8 {answer} />
{:else if question == 9}
  <Question9 {answer} />
{:else if question == 10}
  <Question10 {answer} />
{:else if question == 11}
  <Question11 {answer} />
{:else if question == 12}
  <Question12 {answer} />
{:else if question == 13}
  <Question13 {answer} />
{:else if question == 14}
  <Question14 {answer} />
{:else if question == 15}
  <Question15 {answer} />
{/if}
